/**
 * Bridge.js
 * 适应于壹心理js调用native方法
 *
 * ex:
 * var bridge = new Bridge({
 * 	methods:[
 * 		{
 * 			method: "goBack",
 * 			callback: function(param){}
 * 		}
 * 	]
 * });
 *
 * bridge.call("setTitle",{title:"我是标题"});
 * options.disInitAppHook true为不执行AppHookInit
 */

// docs: http://112.124.122.87:8090/pages/viewpage.action?pageId=5570901

import { getPlatform } from '../tools/getPlatform.js'
import { versionfunegt } from '../tools/utils.js'
// import { isEmpObj } from './index.js'
// 判断Object 是否为空
function isEmpObj(obj) {
  let t
  for (t in obj) {
    return !1
  }
  return !0
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}

function anyToJSON(anythink) {
  if (typeof anythink === 'object') return anythink
  try {
    var at = JSON.parse(anythink)
    if (typeof at === 'object') return at
  } catch (e) {
    console.log(e)
  }
  return anythink
}

let waitWebViewJavascriptBridgeTimer = null
let methodArrays = []
class Bridge {
  constructor(options) {
    this.callMethodsResolve = null
    this.version = '0.1'
    this.platform = getPlatform()
    if (!options || (options && !options.disInitAppHook)) {
      this.AppHookInit()
    }
    this.ready = null
    this._init(options)

    this.getAppVersionPromise()
  }

  getAppVersionPromise() {
    if (typeof this.isNewApp !== 'undefined')
      return Promise.resolve(this.isNewApp)
    return new Promise(resolve => {
      this.call('getAppVervison', {}, version => {
        const isNewApp = versionfunegt(
          version,
          this.platform.isAndroid ? ' 1.3.0' : '1.4.1'
        )
        // window.localStorage.setItem('isNewApp', isNewApp ? '1' : '0')
        this.isNewApp = isNewApp
        resolve()
      })
    })
  }

  _init(options) {
    let self = this
    this.connectWebViewJavascriptBridge(function(bridge) {
      // bridge.init(function(message, responseCallback) {
      //     console.log('JS got a message', message)
      //     let data = {
      //         'Javascript Responds': '测试中文!'
      //     }
      //     if (responseCallback) {
      //         console.log('JS responding with', data)
      //         responseCallback(data)
      //     }
      // // })
      // if (options && options.methods && options.methods.length) {
      //   let methods = options.methods
      //   for (let i = 0; i < methods.length; i++) {
      //     self.MethodCall(methods[i])
      //   }
      // }
      if (options && options.methods) {
        self.add(options.methods)
      }
    })
  }

  connectWebViewJavascriptBridge(callback) {
    let system =
      this.platform.isiPhone || this.platform.isiPad ? 'Ios' : 'Android'
    if (system === 'Ios') {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
      }
      if (window.WVJBCallbacks) {
        console.log(window.WVJBCallbacks)
        return window.WVJBCallbacks.push(callback)
      }
      window.WVJBCallbacks = [callback]
      var WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    } else {
      if (!isEmpObj(window.WebViewJavascriptBridge)) {
        callback(window.WebViewJavascriptBridge)
      } else {
        document.addEventListener(
          'WebViewJavascriptBridgeReady',
          function() {
            console.log('webview加载回调')
            callback(window.WebViewJavascriptBridge)
          },
          false
        )
      }
    }
  }

  add(option) {
    if (isObject(option) && isArray(option.methods)) {
      option = option.methods
    }
    if (isObject(option) && !isArray(option)) {
      option = [option]
    }

    if (!window.callbackNameMethodsCache) {
      window.callbackNameMethodsCache = {}
    }

    if (Array.isArray(option)) {
      for (let i = 0; i < option.length; i++) {
        var obj = option[i]
        window.callbackNameMethodsCache[obj.method] = obj.callback
      }
    }

    console.log(
      `window.callbackNameMethodsCache`,
      window.callbackNameMethodsCache
    )

    this.connectWebViewJavascriptBridge(() => {
      if (!isArray(option)) return
      this.MethodCall({
        method: 'methodForNative',
        callback: data => {
          const obj = (data && JSON.parse(data)) || {}
          const param =
            obj['param'] && obj['param'].includes('{')
              ? JSON.parse(obj['param'])
              : {}
          const target = option.find(v => v.method === obj.intention)
          target && target.callback(param)
        },
        responseCallbackData: {
          type: 0
        }
      })
    })
  }

  MethodCall(obj) {
    const ERROR_TITLE = '[Bridge.js] error : '
    // try {
    if (!obj.method) throw `${ERROR_TITLE} method undefined`
    if (!obj.callback) throw `${ERROR_TITLE} callback undefined`

    console.log(`咨询师bridge MethodCall 方法`, obj)
    console.log(
      `window.WebViewJavascriptBridge`,
      window.WebViewJavascriptBridge
    )

    window.WebViewJavascriptBridge.registerHandler(obj.method, function(
      data,
      responseCallback
    ) {
      // console.log('交互方法执行', data, typeof data, JSON.parse(data))
      obj.callback(data)
      if (responseCallback) {
        responseCallback(obj.responseCallbackData)
      }
    })
    // } catch (err) {
    //   console.error(`${ERROR_TITLE} MethodCall register failed`, err)
    // }
  }
  /**
   * public 调用原生方法 js2native
   * @param  {[string]} callName [方法名称]
   * @param  {[object]} options  [参数]
   */
  call(callName, options, callback) {
    let self = this
    if (this.platform.isMobile) {
      // 如果是新的App，就用新的app api
      // if (window.localStorage.getItem('isNewApp') === '1') {
      const waitReady =
        callName === 'getAppVervison'
          ? Promise.resolve()
          : this.getAppVersionPromise()

      console.log(`咨询师bridge call 方法`, callName, options, callback)
      if (!options) {
        options = {}
      }

      console.log(
        `callName
        options.callbackName &&
        !callback &&
        window.callbackNameMethodsCache[options.callbackName]`,
        callName,
        options.callbackName,
        !callback,
        window.callbackNameMethodsCache &&
          window.callbackNameMethodsCache[options.callbackName]
      )
      if (options.callbackName && !callback) {
        callback = (...args) => {
          if (
            window.callbackNameMethodsCache &&
            typeof window.callbackNameMethodsCache[options.callbackName] ===
              'function'
          ) {
            console.log(
              `callNamecallName`,
              callName,
              window.callbackNameMethodsCache[options.callbackName]
            )
            window.callbackNameMethodsCache[options.callbackName](...args)
          }
        }
        console.log(`options.callbackName`, options.callbackName)
        console.log(`options.callbackName`, callback)
      }

      waitReady.then(() => {
        if (this.isNewApp) {
          this.zxsCall(callName, options, callback)
          return
        }
        if (isEmpObj(window.WebViewJavascriptBridge)) {
          methodArrays.push({
            callName,
            options,
            callback
          })
          if (!waitWebViewJavascriptBridgeTimer) {
            waitWebViewJavascriptBridgeTimer = setInterval(() => {
              if (!isEmpObj(window.WebViewJavascriptBridge)) {
                // 事件释放
                methodArrays.forEach(({ callName, options, callback }) => {
                  window.WebViewJavascriptBridge.callHandler(
                    callName,
                    options,
                    function(responseData) {
                      callback(responseData)
                    }
                  )
                })
                clearInterval(waitWebViewJavascriptBridgeTimer)
                waitWebViewJavascriptBridgeTimer = null
              }
            }, 500)
          }
        } else {
          return new Promise((resolve, reject) => {
            try {
              window.WebViewJavascriptBridge.callHandler(
                callName,
                options,
                function(responseData) {
                  callback(responseData)
                }
              )
            } catch (err) {
              document.addEventListener(
                'WebViewJavascriptBridgeReady',
                function() {
                  window.WebViewJavascriptBridge.callHandler(
                    callName,
                    options,
                    function(responseData) {
                      callback(responseData)
                    }
                  )
                },
                false
              )
              // console.error(err)
              // reject(err)
            }
            if (options.callbackName) {
              self.callMethodsResolve = resolve
            } else {
              resolve()
            }
          })
        }
      })
    }
  }
  zxsCall(callName, obj, callback) {
    let self = this
    if (obj && obj.hasOwnProperty('params')) {
      obj.param = obj.params
      delete obj.params
    }
    let options = obj
    if (this.platform.isMobile) {
      if (isEmpObj(window.WebViewJavascriptBridge)) {
        methodArrays.push({
          callName,
          options,
          callback
        })
        if (!waitWebViewJavascriptBridgeTimer) {
          waitWebViewJavascriptBridgeTimer = setInterval(() => {
            if (!isEmpObj(window.WebViewJavascriptBridge)) {
              // 事件释放
              methodArrays.forEach(({ callName, options, callback }) => {
                window.WebViewJavascriptBridge.callHandler(
                  'methodForJs',
                  {
                    intention: callName,
                    param: JSON.stringify(options)
                  },
                  function(responseData) {
                    callback(anyToJSON(responseData))
                  }
                )
              })
              clearInterval(waitWebViewJavascriptBridgeTimer)
              waitWebViewJavascriptBridgeTimer = null
            }
          }, 500)
        }
      } else {
        return new Promise((resolve, reject) => {
          try {
            window.WebViewJavascriptBridge.callHandler(
              'methodForJs',
              {
                intention: callName,
                param: JSON.stringify(options)
              },
              function(responseData) {
                callback(anyToJSON(responseData))
              }
            )
          } catch (err) {
            document.addEventListener(
              'WebViewJavascriptBridgeReady',
              function() {
                window.WebViewJavascriptBridge.callHandler(
                  'methodForJs',
                  {
                    intention: callName,
                    param: JSON.stringify(options)
                  },
                  function(responseData) {
                    callback(anyToJSON(responseData))
                  }
                )
              },
              false
            )
            // console.error(err)
            // reject(err)
          }
          if (options.callbackName) {
            self.callMethodsResolve = resolve
          } else {
            resolve()
          }
        })
      }
    }
  }
  ciKeCall(callName, options, callback) {
    let self = this
    console.log('callName:', callName)
    console.log('options:', options)
    if (this.platform.isMobile) {
      if (isEmpObj(window.WebViewJavascriptBridge)) {
        methodArrays.push({
          callName,
          options,
          callback
        })
        if (!waitWebViewJavascriptBridgeTimer) {
          waitWebViewJavascriptBridgeTimer = setInterval(() => {
            if (!isEmpObj(window.WebViewJavascriptBridge)) {
              // 事件释放
              methodArrays.forEach(({ callName, options, callback }) => {
                window.WebViewJavascriptBridge.callHandler(
                  'methodForJs',
                  {
                    intention: callName,
                    param: JSON.stringify(options)
                  },
                  function(responseData) {
                    console.log('callback---')
                    callback(responseData)
                  }
                )
              })
              clearInterval(waitWebViewJavascriptBridgeTimer)
              waitWebViewJavascriptBridgeTimer = null
            }
          }, 500)
        }
      } else {
        return new Promise((resolve, reject) => {
          try {
            window.WebViewJavascriptBridge.callHandler(
              'methodForJs',
              {
                intention: callName,
                param: JSON.stringify(options)
              },
              function(responseData) {
                console.log('callback---')
                callback(responseData)
              }
            )
          } catch (err) {
            document.addEventListener(
              'WebViewJavascriptBridgeReady',
              function() {
                window.WebViewJavascriptBridge.callHandler(
                  'methodForJs',
                  {
                    intention: callName,
                    param: JSON.stringify(options)
                  },
                  function(responseData) {
                    console.log('callback---')
                    callback(responseData)
                  }
                )
              },
              false
            )
            // console.error(err)
            // reject(err)
          }
          if (options.callbackName) {
            self.callMethodsResolve = resolve
          } else {
            resolve()
          }
        })
      }
    }
  }
  AppHookInit() {
    console.log('初始化APP事件')
    let codeEventMap = {
      appWebviewShow: 'appWebviewShow',
      appWebviewHide: 'appWebviewHide'
    }
    let eventFactory = function(code) {
      let eventName = codeEventMap[code]
      return new Event(eventName)
    }

    window.yxlAppCustomEvent = {}
    for (let key in codeEventMap) {
      window.yxlAppCustomEvent[key] = eventFactory(key)
      this.connectWebViewJavascriptBridge(() => {
        this.MethodCall({
          method: 'methodForNative',
          callback: data => {
            const obj = (data && JSON.parse(data)) || {}
            window.dispatchEvent(window.yxlAppCustomEvent[obj.intention])
          },
          responseCallbackData: {}
        })
      })
    }
  }
}

export default Bridge

/*
 var myBridge = new Bridge({
     methods: [{
         method: "test",
         callback: function(param) {
           alert("hello world");
         }
     }]
 });

 myBridge.call("setTitle",{title:"我是标题"});
 */



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/zxsBridge.js